// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {i18n} from '@/plugins'
import {urlPath} from '@/utils'

export const MENU = [
  {
    title: i18n.t(urlPath.SALE.name) as string,
    img: 'sale-amount.png',
    path: urlPath.SALE.path
  },
  {
    title: i18n.t(urlPath.CALCULATE_SUMMARY.name) as string,
    icon: 'mdi-table-large',
    path: urlPath.CALCULATE_SUMMARY.path
  },
  {
    title: i18n.t(urlPath.STANDING_ORDER.name) as string,
    img: 'standing-order.png',
    path: urlPath.STANDING_ORDER.path
  },
  {
    title: i18n.t(urlPath.REMAINING.name) as string,
    img: 'remaining.png',
    path: urlPath.REMAINING.path
  },
  {
    title: i18n.t(urlPath.MASTER_PRODUCT.name) as string,
    img: 'processed_product.png',
    path: urlPath.MASTER_PRODUCT.path
  },
  {
    title: i18n.t('menu.master.title') as string,
    icon: 'mdi-cogs',
    children: [
      {
        title: i18n.t('processing_company.title') as string,
        path: urlPath.PROCESSING_COMPANY.path
      },
      {
        title: i18n.t('material_family.title') as string,
        path: '/master/material-family'
      },
      {
        title: i18n.t('master.box_type.title') as string,
        path: '/master/box-type'
      },
      {
        title: i18n.t('master.bloom_num.title') as string,
        path: '/master/bloom'
      },
      {
        title: i18n.t('master.size.title') as string,
        path: '/master/size'
      },
      {
        title: i18n.t('master.grade.title') as string,
        path: '/master/grade'
      },
      {
        title: i18n.t('master.supplier.title') as string,
        path: '/master/supplier'
      },
      {
        title: i18n.t('master.customer.title') as string,
        path: '/master/customer'
      },
      {
        title: i18n.t('master.logistic_company.title') as string,
        path: '/master/logistic-company'
      },
      {
        title: i18n.t('master.user.title') as string,
        path: '/master/user'
      }
    ]
  }
]
